import { ContactSection } from '../home/contact-section'
import { SiteFooter } from '../layout/site-footer'
import { SiteHeader } from '../layout/site-header'
import { PageTitle } from '../seo/page-title'

export interface ContactPageProps {}

export function ContactPage(_: Readonly<ContactPageProps>) {
  return (
    <div className="autoglow-home page-shell contact-page">
      <PageTitle title="Contact Autoglow Detailing | Geelong & Bellarine" />
      <SiteHeader />
      <main id="main">
        <ContactSection />
      </main>
      <SiteFooter />
    </div>
  )
}

export default ContactPage
